export const TUTORIAL_TYPES = ({
  TOOL: 'Tools',
  SIDE_PANEL: 'Side Panel',
  VIDEO: 'Video'
} as const);
export const COMPLETE_TUTORIAL_MESSAGE = 'Please complete the currently active tutorial before requesting a new one.';
export const TUTORIAL_DISPLAY_NAME = ({
  annotation: 'Select, Hide and Delete Annotation',
  label: 'Change label color'
} as const);
export const TUTORIAL_ERROR_MESSAGE = ({
  annotation: 'Please create at least 1 annotation to trigger this tutorials.'
} as const);